import React, {PureComponent} from 'react';
import {PageContent} from 'aui-react';

import Intro from '../Intro/Intro';
import NewEventsTable from '../NewEventsTable/NewEventsTable';
import OldEventTable from '../OldEventsTable/OldEventsTable';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import SubHeader from '../SubHeader/SubHeader';
import Spinner from '../Spinner/Spinner';

import styles from '../../styles/styles.less';

export class Body extends PureComponent {
    render() {
        return (
            <div>
                <Header />
                <PageContent className={styles.mainContent}>
                    <SubHeader />
                    <Intro />
                    <NewEventsTable />
                    <OldEventTable />
                    <Spinner />
                    <Footer />
                </PageContent>
            </div>
        );
    }
}

export default Body;



// WEBPACK FOOTER //
// ./src/components/Body/Body.js